(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["activepedal-sport-launch-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sc-aps-hero-media')) {
    customElements.define(
      'sc-aps-hero-media',
      class extends HTMLElement {
        connectedCallback() {
          this.video = this.querySelector('[data-hero-video]');
          this.embedTpl = this.querySelector('[data-hero-embed]');
          this.embedSlot = this.querySelector('[data-embed-slot]');
          this.playBtn = this.querySelector('[data-hero-play]');
          this.soundBtn = this.querySelector('[data-hero-sound]');
          this.soundLabel = this.querySelector('[data-hero-sound-label]');
          if (!this.video && !this.embedTpl) return;

          this.onPlayClick = () => (this.playing ? this.stop() : this.start());
          this.onSoundClick = () => this.toggleSound();
          this.onVideoPlay = () => this.setPlaying(true);
          this.onVideoPause = () => this.setPlaying(false);
          this.onTimeUpdate = () => this.detectAudio();

          if (this.playBtn) this.playBtn.addEventListener('click', this.onPlayClick);
          if (this.soundBtn) this.soundBtn.addEventListener('click', this.onSoundClick);
          if (this.video) {
            this.video.addEventListener('play', this.onVideoPlay);
            this.video.addEventListener('pause', this.onVideoPause);
            if (this.soundBtn) this.video.addEventListener('timeupdate', this.onTimeUpdate);
          }

          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (reduceMotion) {
            // No autoplay: keep the poster and offer a play button.
            if (this.playBtn) this.playBtn.hidden = false;
            this.setPlaying(false);
          } else {
            this.start();
          }
        }

        disconnectedCallback() {
          if (this.playBtn) this.playBtn.removeEventListener('click', this.onPlayClick);
          if (this.soundBtn) this.soundBtn.removeEventListener('click', this.onSoundClick);
          if (this.video) {
            this.video.removeEventListener('play', this.onVideoPlay);
            this.video.removeEventListener('pause', this.onVideoPause);
            this.video.removeEventListener('timeupdate', this.onTimeUpdate);
          }
        }

        start() {
          if (this.video) {
            const attempt = this.video.play();
            if (attempt && typeof attempt.catch === 'function') {
              attempt.catch(() => this.setPlaying(false));
            }
            return;
          }
          if (this.embedTpl && this.embedSlot && !this.embedSlot.firstElementChild) {
            this.embedSlot.appendChild(this.embedTpl.content.cloneNode(true));
          }
          this.setPlaying(true);
        }

        stop() {
          if (this.video) {
            this.video.pause();
            return;
          }
          if (this.embedSlot) this.embedSlot.replaceChildren();
          this.setPlaying(false);
        }

        setPlaying(state) {
          this.playing = state;
          if (!this.playBtn) return;
          this.playBtn.dataset.state = state ? 'playing' : 'paused';
          this.playBtn.setAttribute('aria-label', state ? 'Pause video' : 'Play video');
        }

        // Only show the sound button once we know the file has an audio track.
        detectAudio() {
          const v = this.video;
          if (!v || v.currentTime < 0.3) return;
          const hasAudio =
            Boolean(v.mozHasAudio) ||
            (typeof v.webkitAudioDecodedByteCount === 'number' && v.webkitAudioDecodedByteCount > 0) ||
            Boolean(v.audioTracks && v.audioTracks.length > 0);
          if (hasAudio) this.soundBtn.hidden = false;
          v.removeEventListener('timeupdate', this.onTimeUpdate);
        }

        toggleSound() {
          if (!this.video || !this.soundBtn) return;
          const soundOn = this.video.muted;
          this.video.muted = !soundOn;
          if (soundOn) this.start();
          this.soundBtn.setAttribute('aria-pressed', String(soundOn));
          if (this.soundLabel) {
            this.soundLabel.textContent = soundOn ? this.soundBtn.dataset.labelOn : this.soundBtn.dataset.labelOff;
          }
        }
      }
    );
  }

  // Same sign-up element as the launch hero. The guard means whichever loads first defines it.
  if (!customElements.get('sc-aps-signup')) {
    customElements.define(
      'sc-aps-signup',
      class extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('[data-signup-form]');
          this.errorEl = this.querySelector('[data-signup-error]');
          this.statusEl = this.querySelector('[data-signup-status]');
          this.successTpl = this.querySelector('[data-signup-success]');
          this.submitBtn = this.form ? this.form.querySelector('[type="submit"]') : null;
          if (!this.form) return;

          this.onSubmit = (event) => this.handleSubmit(event);
          this.form.addEventListener('submit', this.onSubmit);
        }

        disconnectedCallback() {
          if (this.form) this.form.removeEventListener('submit', this.onSubmit);
        }

        getCookie(name) {
          const match = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
          return match ? decodeURIComponent(match[1]) : '';
        }

        setError(message) {
          this.errorEl.textContent = message || '';
        }

        async handleSubmit(event) {
          event.preventDefault();
          if (this.busy) return;

          const { portalId, formGuid, customerProperty, subscriptionTypeId, consentText, legalText } = this.dataset;
          if (!portalId || !formGuid) return;

          this.setError('');

          const data = new FormData(this.form);
          const email = String(data.get('email') || '').trim();
          const answer = data.get('existing_customer');

          const fields = [{ objectTypeId: '0-1', name: 'email', value: email }];
          if (answer && customerProperty) {
            fields.push({ objectTypeId: '0-1', name: customerProperty, value: String(answer) });
          }

          const context = { pageUri: window.location.href, pageName: document.title };
          const hutk = this.getCookie('hubspotutk');
          if (hutk) context.hutk = hutk;

          const consent = { consentToProcess: true, text: legalText };
          if (subscriptionTypeId) {
            consent.communications = [
              { value: true, subscriptionTypeId: Number(subscriptionTypeId), text: consentText },
            ];
          }

          const payload = {
            fields,
            context,
            legalConsentOptions: { consent },
          };

          this.busy = true;
          this.submitBtn.disabled = true;
          this.submitBtn.setAttribute('aria-busy', 'true');

          try {
            const response = await fetch(
              'https://api.hsforms.com/submissions/v3/integration/submit/' +
                encodeURIComponent(portalId) +
                '/' +
                encodeURIComponent(formGuid),
              {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
              }
            );

            if (!response.ok) {
              let body = null;
              try {
                body = await response.json();
              } catch (e) {
                body = null;
              }
              const invalidEmail =
                body &&
                Array.isArray(body.errors) &&
                body.errors.some((err) => err && err.errorType === 'INVALID_EMAIL');
              throw new Error(invalidEmail ? 'invalid_email' : 'request_failed');
            }

            this.showSuccess(answer ? String(answer) : 'unanswered');
          } catch (error) {
            this.setError(
              error && error.message === 'invalid_email' ? this.dataset.errorEmailText : this.dataset.errorText
            );
            this.busy = false;
            this.submitBtn.disabled = false;
            this.submitBtn.removeAttribute('aria-busy');
          }
        }

        showSuccess(existingCustomer) {
          this.form.hidden = true;
          if (this.successTpl) {
            this.statusEl.replaceChildren(this.successTpl.content.cloneNode(true));
          }
          this.statusEl.focus();

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'early_access_signup',
            form_location: 'hero',
            existing_customer: existingCustomer,
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simucube-aps-any-role"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sc-aps-any-role')) {
    customElements.define(
      'sc-aps-any-role',
      class extends HTMLElement {
        connectedCallback() {
          this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
          if (!this.tabs.length) return;

          this.onClick = (event) => {
            const tab = event.target.closest('[role="tab"]');
            if (tab) this.select(tab, false);
          };

          this.onKeydown = (event) => {
            const tab = event.target.closest('[role="tab"]');
            if (!tab) return;
            const i = this.tabs.indexOf(tab);
            const last = this.tabs.length - 1;
            let next = null;
            if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = i === last ? 0 : i + 1;
            if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = i === 0 ? last : i - 1;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = last;
            if (next === null) return;
            event.preventDefault();
            this.select(this.tabs[next], true);
          };

          this.onBlockSelect = (event) => {
            const tab = this.tabs.find((t) => t.dataset.blockId === event.detail.blockId);
            if (tab) this.select(tab, false);
          };

          this.addEventListener('click', this.onClick);
          this.addEventListener('keydown', this.onKeydown);
          document.addEventListener('shopify:block:select', this.onBlockSelect);
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.onClick);
          this.removeEventListener('keydown', this.onKeydown);
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
        }

        select(tab, focus) {
          this.tabs.forEach((t) => {
            const on = t === tab;
            t.setAttribute('aria-selected', String(on));
            t.tabIndex = on ? 0 : -1;
            const panel = this.querySelector('#' + CSS.escape(t.getAttribute('aria-controls')));
            if (panel) panel.hidden = !on;
          });
          if (focus) tab.focus();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simucube-aps-complete-set"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sc-aps-complete-set')) {
    customElements.define(
      'sc-aps-complete-set',
      class extends HTMLElement {
        connectedCallback() {
          this.buttons = Array.from(this.querySelectorAll('[data-currency-code]'));
          if (!this.buttons.length) return;
          this.onClick = (event) => {
            const btn = event.target.closest('[data-currency-code]');
            if (btn) this.setCurrency(btn.dataset.currencyCode);
          };
          this.addEventListener('click', this.onClick);
        }

        disconnectedCallback() {
          if (this.onClick) this.removeEventListener('click', this.onClick);
        }

        setCurrency(code) {
          const key = code.toLowerCase();
          const values = {
            bundle: this.dataset[key + 'Bundle'] || '',
            single: this.dataset[key + 'Single'] || '',
            note: this.dataset[key + 'Note'] || '',
          };
          this.querySelectorAll('[data-price]').forEach((el) => {
            el.textContent = values[el.dataset.price];
          });
          this.buttons.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.currencyCode === code)));
          this.dataset.currency = code;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simucube-aps-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sc-aps-faq')) {
    customElements.define(
      'sc-aps-faq',
      class extends HTMLElement {
        connectedCallback() {
          this.items = Array.from(this.querySelectorAll('details'));
          this.onClick = (event) => {
            const summary = event.target.closest('summary');
            if (!summary || !this.contains(summary)) return;
            const item = summary.parentElement;
            event.preventDefault();
            if (item.open) {
              this.close(item);
            } else {
              this.items.forEach((other) => {
                if (other !== item && other.open) this.close(other);
              });
              this.open(item);
            }
          };
          this.addEventListener('click', this.onClick);

          this.onBlockSelect = (event) => {
            const item = this.items.find((d) => d.contains(event.target));
            if (item && !item.open) {
              this.items.forEach((other) => {
                if (other !== item && other.open) this.close(other);
              });
              this.open(item);
            }
          };
          document.addEventListener('shopify:block:select', this.onBlockSelect);
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.onClick);
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
        }

        get reduceMotion() {
          return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        }

        open(item) {
          item.open = true;
          const answer = item.querySelector('[data-faq-answer]');
          if (!answer || this.reduceMotion || !answer.animate) return;
          const height = answer.scrollHeight;
          answer.animate([{ height: '0px' }, { height: height + 'px' }], { duration: 220, easing: 'ease-out' });
        }

        close(item) {
          const answer = item.querySelector('[data-faq-answer]');
          if (!answer || this.reduceMotion || !answer.animate) {
            item.open = false;
            return;
          }
          const animation = answer.animate([{ height: answer.scrollHeight + 'px' }, { height: '0px' }], {
            duration: 200,
            easing: 'ease-in',
          });
          animation.onfinish = () => {
            item.open = false;
          };
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simucube-aps-foot-force"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sc-aps-foot-force')) {
    customElements.define(
      'sc-aps-foot-force',
      class extends HTMLElement {
        connectedCallback() {
          this.onClick = (event) => {
            const chip = event.target.closest('[data-effect-key]');
            if (!chip) return;
            const target = document.getElementById(this.dataset.target || 'effects');
            if (!target) return; // let the link behave normally
            event.preventDefault();

            const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            // scroll-margin-top on the effects section handles the header offset
            target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
            if (window.history && window.history.replaceState) {
              window.history.replaceState(null, '', '#' + target.id);
            }

            document.dispatchEvent(
              new CustomEvent('sc-aps:select-effect', { detail: { key: chip.dataset.effectKey } })
            );
          };
          this.addEventListener('click', this.onClick);
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.onClick);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simucube-aps-sticky-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sc-aps-sticky-bar')) {
    customElements.define(
      'sc-aps-sticky-bar',
      class extends HTMLElement {
        connectedCallback() {
          this.designMode = this.hasAttribute('data-design-mode');

          // On the live site, move the bar to <body>. Theme wrappers around sections
          // (scroll-reveal opacity, transforms, overflow) would otherwise hide or clip
          // a fixed element. In the theme editor it stays put so it can be selected.
          if (!this.designMode && this.parentElement !== document.body) {
            document.body.appendChild(this);
            return; // connectedCallback runs again once it is in <body>
          }

          if (this.bound) return;
          this.bound = true;
          this.heroPast = false;

          this.onClose = () => {
            try {
              window.sessionStorage.setItem('apsport-bar-off', '1');
            } catch (e) {
              /* storage unavailable */
            }
            this.dismissed = true;
            this.update();
          };

          // Button mode only: jump to the hero form and focus its email field.
          this.onCta = (event) => {
            const hero = this.findHero();
            if (!hero) return;
            event.preventDefault();
            const email = hero.querySelector('input[type="email"]');
            const target = (email && (email.closest('sc-aps-signup') || email)) || hero;
            const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
            if (email) window.setTimeout(() => email.focus({ preventScroll: true }), reduce ? 0 : 450);
          };

          // Signed up anywhere: hide. If it was this bar's own form, show the success state for a moment first.
          this.onSignedUp = () => {
            this.signedUp = true;
            const ownForm = this.querySelector('sc-aps-signup');
            const fromHere = ownForm && ownForm.contains(document.activeElement);
            if (fromHere) {
              window.setTimeout(() => this.update(), 4000);
            } else {
              this.update();
            }
          };

          this.onSectionSelect = (event) => {
            if (event.detail && event.detail.sectionId === this.dataset.sectionId) {
              this.editorSelected = true;
              this.update();
            }
          };

          // Editing a setting re-renders the section without a new select event, so treat a reload as selected.
          this.onSectionLoad = (event) => {
            if (event.detail && event.detail.sectionId === this.dataset.sectionId) {
              this.editorSelected = true;
              this.update();
            }
          };

          this.onSectionDeselect = (event) => {
            if (event.detail && event.detail.sectionId === this.dataset.sectionId) {
              this.editorSelected = false;
              this.update();
            }
          };

          // Open out the customer question and consent box as soon as the visitor starts on the form.
          this.onFocusIn = (event) => {
            if (event.target.closest('[data-signup-form]')) this.classList.add('is-expanded');
          };
          this.addEventListener('focusin', this.onFocusIn);

          this.close = this.querySelector('[data-sticky-close]');
          this.cta = this.querySelector('[data-sticky-cta]');
          this.bar = this.querySelector('.sc-aps-sticky__bar');
          if (this.close) this.close.addEventListener('click', this.onClose);
          if (this.cta) this.cta.addEventListener('click', this.onCta);
          document.addEventListener('sc-aps:signed-up', this.onSignedUp);
          document.addEventListener('shopify:section:select', this.onSectionSelect);
          document.addEventListener('shopify:section:deselect', this.onSectionDeselect);
          document.addEventListener('shopify:section:load', this.onSectionLoad);

          // Reserve space under the page equal to the bar's real height (it grows on mobile with the form).
          if (this.bar && 'ResizeObserver' in window) {
            this.resizeObserver = new ResizeObserver(() => this.setSpace());
            this.resizeObserver.observe(this.bar);
          }

          try {
            this.signedUp = Boolean(window.localStorage.getItem('apsport-signup'));
          } catch (e) {
            this.signedUp = false;
          }
          try {
            this.dismissed = window.sessionStorage.getItem('apsport-bar-off') === '1';
          } catch (e) {
            this.dismissed = false;
          }

          const hero = this.findHero();
          if (hero && 'IntersectionObserver' in window && !this.designMode) {
            this.observer = new IntersectionObserver((entries) => {
              const entry = entries[entries.length - 1];
              // Fully out of view and above the viewport (scrolled past it)
              this.heroPast = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
              this.update();
            });
            this.observer.observe(hero);
          }

          // A bar that connects inside the editor after the first page load is a re-render of the selected section.
          if (this.designMode && window.Shopify && window.Shopify.designMode && document.readyState === 'complete') {
            this.editorSelected = true;
          }

          this.setSpace();
          this.update();
        }

        disconnectedCallback() {
          if (!this.bound) return;
          this.bound = false;
          if (this.close) this.close.removeEventListener('click', this.onClose);
          if (this.cta) this.cta.removeEventListener('click', this.onCta);
          document.removeEventListener('sc-aps:signed-up', this.onSignedUp);
          document.removeEventListener('shopify:section:select', this.onSectionSelect);
          document.removeEventListener('shopify:section:deselect', this.onSectionDeselect);
          document.removeEventListener('shopify:section:load', this.onSectionLoad);
          if (this.observer) this.observer.disconnect();
          if (this.resizeObserver) this.resizeObserver.disconnect();
          this.removeEventListener('focusin', this.onFocusIn);
          document.documentElement.classList.remove('sc-aps-sticky-on');
        }

        // The configured selector first; if it isn't on the page, fall back to the APS hero itself.
        findHero() {
          const selector = this.dataset.hero || '#top';
          let hero = null;
          try {
            hero = document.querySelector(selector);
          } catch (e) {
            hero = null;
          }
          return hero || document.querySelector('.sc-aps-hero') || document.querySelector('.sc-aps-hero-section');
        }

        setSpace() {
          if (!this.bar) return;
          const gap = parseFloat(getComputedStyle(this).bottom) || 20;
          document.documentElement.style.setProperty(
            '--sc-aps-sticky-space',
            Math.ceil(this.bar.offsetHeight + gap * 2) + 'px'
          );
        }

        update() {
          let show;
          if (this.designMode) {
            show = Boolean(this.editorSelected);
          } else {
            show = this.heroPast && !this.signedUp && !this.dismissed;
          }
          this.dataset.state = show ? 'visible' : 'hidden';
          document.documentElement.classList.toggle('sc-aps-sticky-on', show);
        }
      }
    );
  }

  // Shared early-access sign-up element. Identical copy in every APS section that has a form,
  // so whichever section's script loads first defines it. One sign-up state for the whole page.
  if (!customElements.get('sc-aps-signup')) {
    customElements.define(
      'sc-aps-signup',
      class extends HTMLElement {
        static get storageKey() {
          return 'apsport-signup';
        }

        static isSignedUp() {
          try {
            return Boolean(window.localStorage.getItem('apsport-signup'));
          } catch (e) {
            return false;
          }
        }

        connectedCallback() {
          this.form = this.querySelector('[data-signup-form]');
          this.errorEl = this.querySelector('[data-signup-error]');
          this.statusEl = this.querySelector('[data-signup-status]');
          this.successTpl = this.querySelector('[data-signup-success]');
          this.submitBtn = this.form ? this.form.querySelector('[type="submit"]') : null;
          if (!this.form) return;

          this.onSubmit = (event) => this.handleSubmit(event);
          this.onSignedUp = () => this.showSuccess(null, false);
          this.form.addEventListener('submit', this.onSubmit);
          document.addEventListener('sc-aps:signed-up', this.onSignedUp);

          // Already signed up on an earlier visit: show the success state straight away.
          if (this.constructor.isSignedUp()) this.showSuccess(null, false);
        }

        disconnectedCallback() {
          if (this.form) this.form.removeEventListener('submit', this.onSubmit);
          document.removeEventListener('sc-aps:signed-up', this.onSignedUp);
        }

        getCookie(name) {
          const match = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
          return match ? decodeURIComponent(match[1]) : '';
        }

        setError(message) {
          if (this.errorEl) this.errorEl.textContent = message || '';
        }

        async handleSubmit(event) {
          event.preventDefault();
          if (this.busy) return;

          const { portalId, formGuid, customerProperty, subscriptionTypeId, consentText, legalText } = this.dataset;
          if (!portalId || !formGuid) return;

          this.setError('');

          const data = new FormData(this.form);
          const email = String(data.get('email') || '').trim();
          const answer = data.get('existing_customer');
          const consentBox = this.form.querySelector('[name="consent"]');

          const fields = [{ objectTypeId: '0-1', name: 'email', value: email }];
          if (answer && customerProperty) {
            fields.push({ objectTypeId: '0-1', name: customerProperty, value: String(answer) });
          }

          const context = { pageUri: window.location.href, pageName: document.title };
          const hutk = this.getCookie('hubspotutk');
          if (hutk) context.hutk = hutk;

          const consent = { consentToProcess: true, text: legalText };
          if (subscriptionTypeId && consentBox) {
            consent.communications = [
              { value: consentBox.checked, subscriptionTypeId: Number(subscriptionTypeId), text: consentText },
            ];
          }

          const payload = { fields, context, legalConsentOptions: { consent } };

          this.busy = true;
          this.submitBtn.disabled = true;
          this.submitBtn.setAttribute('aria-busy', 'true');

          try {
            const response = await fetch(
              'https://api.hsforms.com/submissions/v3/integration/submit/' +
                encodeURIComponent(portalId) +
                '/' +
                encodeURIComponent(formGuid),
              {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
              }
            );

            if (!response.ok) {
              let body = null;
              try {
                body = await response.json();
              } catch (e) {
                body = null;
              }
              const invalidEmail =
                body &&
                Array.isArray(body.errors) &&
                body.errors.some((err) => err && err.errorType === 'INVALID_EMAIL');
              throw new Error(invalidEmail ? 'invalid_email' : 'request_failed');
            }

            this.showSuccess(answer ? String(answer) : 'unanswered', true);
          } catch (error) {
            this.setError(
              error && error.message === 'invalid_email' ? this.dataset.errorEmailText : this.dataset.errorText
            );
            this.busy = false;
            this.submitBtn.disabled = false;
            this.submitBtn.removeAttribute('aria-busy');
          }
        }

        // isOrigin: true for the form the visitor actually submitted.
        showSuccess(existingCustomer, isOrigin) {
          if (this.done) return;
          this.done = true;
          this.form.hidden = true;
          const warning = this.querySelector('[data-signup-warning]');
          if (warning) warning.hidden = true;
          if (this.successTpl && this.statusEl) {
            this.statusEl.replaceChildren(this.successTpl.content.cloneNode(true));
          }
          if (!isOrigin) return;

          if (this.statusEl) this.statusEl.focus();

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'early_access_signup',
            form_location: this.dataset.formLocation || 'hero',
            existing_customer: existingCustomer,
          });

          // Only a flag and a timestamp are stored, never the email address.
          try {
            window.localStorage.setItem('apsport-signup', JSON.stringify({ at: Date.now() }));
          } catch (e) {
            /* storage unavailable */
          }
          document.dispatchEvent(new CustomEvent('sc-aps:signed-up'));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simucube-aps-tuner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sc-aps-tuner')) {
    customElements.define(
      'sc-aps-tuner',
      class extends HTMLElement {
        static get curves() {
          const log = (k) => (x) => Math.log(1 + k * x) / Math.log(1 + k);
          return {
            linear: { label: 'Linear', f: (x) => x },
            squared: { label: 'Squared', f: (x) => x * x },
            's-curve': { label: 'S-Curve', f: (x) => x * x * (3 - 2 * x) },
            'log-a': { label: 'Logarithmic A', f: log(3) },
            'log-b': { label: 'Logarithmic B', f: log(9) },
            'log-c': { label: 'Logarithmic C', f: log(30) },
          };
        }

        connectedCallback() {
          this.chart = this.querySelector('[data-chart]');
          if (!this.chart) return;
          this.line = this.chart.querySelector('[data-line]');
          this.area = this.chart.querySelector('[data-area]');
          this.points = Array.from(this.chart.querySelectorAll('[data-point]'));
          this.buttons = Array.from(this.querySelectorAll('[data-preset-key]'));
          this.current = this.dataset.preset || 'log-a';
          this.ys = this.sample(this.current);

          this.onClick = (event) => {
            const btn = event.target.closest('[data-preset-key]');
            if (btn) this.select(btn.dataset.presetKey);
          };
          this.addEventListener('click', this.onClick);
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.onClick);
          if (this.raf) cancelAnimationFrame(this.raf);
        }

        // 41 samples for the line plus the 6 control points.
        sample(key) {
          const curve = this.constructor.curves[key] || this.constructor.curves['log-a'];
          const ys = [];
          for (let i = 0; i <= 40; i++) ys.push(curve.f(i / 40));
          for (let i = 1; i <= 6; i++) ys.push(curve.f(i / 6));
          return ys;
        }

        draw(ys) {
          const px = (x) => 44 + x * 540;
          const py = (y) => 220 - y * 204;
          let d = '';
          for (let i = 0; i <= 40; i++) {
            d += (i === 0 ? 'M' : ' L') + px(i / 40).toFixed(1) + ' ' + py(ys[i]).toFixed(1);
          }
          this.line.setAttribute('d', d);
          this.area.setAttribute('d', d + ' L584 220 L44 220 Z');
          this.points.forEach((pt, i) => {
            pt.setAttribute('cx', px((i + 1) / 6).toFixed(1));
            pt.setAttribute('cy', py(ys[41 + i]).toFixed(1));
          });
        }

        select(key) {
          if (!this.constructor.curves[key] || key === this.current) return;
          this.current = key;
          this.buttons.forEach((b) => {
            const on = b.dataset.presetKey === key;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-pressed', String(on));
          });
          this.chart.setAttribute('aria-label', 'Force curve: ' + this.constructor.curves[key].label);

          const from = this.ys.slice();
          const to = this.sample(key);
          this.ys = to;
          if (this.raf) cancelAnimationFrame(this.raf);

          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            this.draw(to);
            return;
          }

          const start = performance.now();
          const step = (now) => {
            const p = Math.min(1, (now - start) / 250);
            const e = 1 - Math.pow(1 - p, 3);
            this.draw(from.map((y, i) => y + (to[i] - y) * e));
            if (p < 1) this.raf = requestAnimationFrame(step);
          };
          this.raf = requestAnimationFrame(step);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simucube-testimonials"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.testimonials__card').forEach((card) => {
    const playButton = card.querySelector('.testimonials__play');
    const video = card.querySelector('.testimonials__video');
    if (!playButton || !video) return;

    const showVideo = () => {
      card.classList.add('testimonials__card--playing');
      video.controls = true;
      video.muted = false;
      video.play();
    };

    const restoreOverlay = () => {
      card.classList.remove('testimonials__card--playing');
      video.controls = false;
      video.muted = true;
    };

    card.addEventListener('click', (event) => {
      if (event.target.closest('.testimonials__video')) return;
      if (card.classList.contains('testimonials__card--playing')) {
        video.pause();
      } else {
        showVideo();
      }
    });

    video.addEventListener('pause', restoreOverlay);

    video.addEventListener('ended', () => {
      restoreOverlay();
      video.currentTime = 0;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
